var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tw-w-full tw-p-3 feature-set-container" }, [
    _c(
      "div",
      { staticClass: "tw-p-6 tw-flex tw-flex-row tw-items-center header" },
      [
        _c(
          "div",
          {
            staticClass:
              "tw-w-8 tw-h-8 tw-rounded-full tw-text-center tw-mr-4 tw-text-white tw-self-center tw-ml-4 tw-items-center tw-justify-center tw-inline-flex tw-font-semibold pill",
            class: _vm.completed ? "pill-green" : "pill-blue"
          },
          [_vm._v(" " + _vm._s(_vm.step) + " ")]
        ),
        _c("h2", { staticClass: "tw-text-2xl tw-inline tw-font-semibold" }, [
          _vm._v("Base Details")
        ])
      ]
    ),
    _c("div", { staticClass: "tw-flex tw-flex-col tw-py-4 tw-px-10" }, [
      _c(
        "div",
        {
          staticClass:
            "tw-flex tw-flex-col tw-flex-grow-0 tw-mb-4 feature-input"
        },
        [
          _c(
            "label",
            {
              staticClass: "block tw-text-sm tw-text-footy-red tw-pl-1",
              attrs: { for: "country" }
            },
            [_vm._v(" Country ")]
          ),
          _c(
            "div",
            { staticClass: "relative" },
            [
              _c("v-select", {
                ref: "selectCountry",
                attrs: {
                  id: "country",
                  disabled: _vm.disabled || _vm.completed,
                  items: _vm.countries,
                  "item-text": "name",
                  "item-value": "id",
                  dense: "",
                  outlined: "",
                  "background-color": "white",
                  tabindex: "1"
                },
                model: {
                  value: _vm.form.country,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "country", $$v)
                  },
                  expression: "form.country"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "tw-flex tw-flex-col tw-flex-grow-0 tw-mb-4 feature-input"
        },
        [
          _c(
            "label",
            {
              staticClass: "block tw-text-sm tw-text-footy-red tw-pl-1",
              attrs: { for: "city" }
            },
            [_vm._v(" City ")]
          ),
          _c(
            "div",
            { staticClass: "relative" },
            [
              _c("v-select", {
                ref: "selectCity",
                attrs: {
                  id: "city",
                  disabled: _vm.disabled || _vm.completed,
                  items: _vm.filteredCities,
                  "item-text": "name",
                  "item-value": "id",
                  dense: "",
                  outlined: "",
                  "background-color": "white",
                  tabindex: "1"
                },
                model: {
                  value: _vm.form.city,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "city", $$v)
                  },
                  expression: "form.city"
                }
              })
            ],
            1
          )
        ]
      ),
      _c("div", { staticClass: "tw-mb-6 feature-input" }, [
        _c(
          "label",
          {
            staticClass: "block tw-text-sm tw-text-footy-red tw-pl-1 tw-mb-2",
            attrs: { for: "city" }
          },
          [_vm._v(" Display Name ")]
        ),
        _c(
          "div",
          { staticClass: "relative" },
          [
            _c("v-text-field", {
              staticClass: "tw-mt-1",
              attrs: {
                outlined: "",
                "background-color": "white",
                dense: "",
                disabled: _vm.disabled || _vm.completed
              },
              model: {
                value: _vm.form.display_name,
                callback: function($$v) {
                  _vm.$set(_vm.form, "display_name", $$v)
                },
                expression: "form.display_name"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "tw-w-full tw-pt-6 tw-flex button-bar" },
        [
          _c(
            "v-btn",
            {
              staticClass: "tw-mr-6",
              attrs: {
                text: "",
                color: "primary",
                disabled: _vm.disabled || _vm.completed
              },
              on: { click: _vm.handleCancel }
            },
            [_vm._v(" CANCEL ")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "tw-flex-1",
              attrs: {
                disabled: _vm.disabled || _vm.completed,
                color: "primary"
              },
              on: { click: _vm.handleSave }
            },
            [_vm._v(" Create Player of the Match ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }